import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { GET_SEO_DATA } from '@graphql/article/article.query'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

import F1TeamDetail from '@shared/components/f1TeamDetail'
import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { HotStories } from '@shared/components/F1Components/EditorsPick'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function TeamDetailPage({ teamData, news, seo }) {
  const data = news?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults?.slice(0, 3) || []
  const { addTop, mobSm, addBottom, addLeft } = reviveAdData
  return (
    <Layout data={{ oSeo: seo?.getSeoData }}>
      <div className="container pb-5">
        <div className="w-full d-none d-xl-flex justify-content-center my-3">
          <ReviveAds {...addTop} className={'my-3'} />
        </div>
        <div className="w-full d-flex d-xl-none justify-content-center my-1">
          <ReviveAds {...mobSm} className={'my-1'} />
        </div>
        <F1TeamDetail teamData={teamData} />
        <HotStories news={data} />
        <div className="w-full d-flex d-xl-none justify-content-center my-2">
          <ReviveAds {...addLeft} className={'my-2'} />
        </div>
        <div className="w-full d-none d-xl-flex justify-content-center my-3">
          <ReviveAds {...addBottom} className={'my-3 text-center'} />
        </div>
      </div>
    </Layout>
  )
}

TeamDetailPage.propTypes = {
  teamData: PropTypes.object,
  news: PropTypes.object,
  seo: PropTypes.object
}

export default TeamDetailPage

export async function getServerSideProps({ res, resolvedUrl, params }) {
  const { slug } = params
  try {
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: `formula1-racing/teams/${slug?.[0]}` } })

    const BASE_URL = GRAPHQL_URL.replace(/\/graphql$/, '')

    const urlTeamDetails = new URL(`${BASE_URL}/api/global-widget/f1/get/team-details/${seo?.getSeoData?.iId}`)

    const teamDetailResponse = await fetch(urlTeamDetails, {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    })
    const teamDetailData = await teamDetailResponse.json()

    const [news] = await parallelCalls([
      queryGraphql(GET_CATEGORY_NEWS_VIDEOS, {
        input: {
          nLimit: 5,
          nSkip: 0,
          iCategoryId: '66226bd0c8717f761bf48525',
          eType: 'vn'
        }
      })
    ])
    return {
      props: {
        teamData: teamDetailData || {},
        news: news || {},
        seo: seo || {}
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
